<template>
  <v-container>
    <v-card title="Check In">
      <v-card-text>
        <v-data-table-server
          v-model:items-per-page="pagination.limit"
          :items="teams"
          :headers="headersTeam"
          :items-length="count"
          :loading="loading"
          :search="pagination.q"
          item-key="id"
          @update:options="handleLimitChange">
          <template v-slot:[`item.name`]="{ item }">
            <router-link
              :to="{ name: 'AdminYearTeamDetailView', params: { yearId, teamId: item.id } }"
              >{{ item.name }}</router-link
            >
            <v-badge
              v-if="item.teamCriteria[0] && item.teamCriteria[0].notes.length > 0"
              color="green"
              :content="item.teamCriteria[0] && item.teamCriteria[0].notes.length"
              inline
              @click="showNotes(item)"></v-badge>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              text
              :color="item.teamCriteria[0].checked_in ? 'green' : 'grey'"
              @click="!item.teamCriteria[0].checked_in ? checkInTeam(item) : checkOutTeam(item)">
              <v-icon icon="mdi-check-bold"></v-icon>
            </v-btn>
          </template>
          <template v-slot:top>
            <v-text-field
              v-model="pagination.q"
              class="ma-2"
              density="compact"
              placeholder="Search team..."
              hide-details></v-text-field>
          </template>
        </v-data-table-server>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showNotesModal">
      <v-list v-for="note in currentNotes" :key="note.id">
        <v-list-item>
          <v-list-item-title>{{ note.title }}</v-list-item-title>
          <v-list-item-subtitle v-html="note.content"></v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import type { VDataTableServer } from 'vuetify/components';
//import { sendCheckinToDiscord } from '@/controllers/admin/discordController';
import { useTeamStore } from '@/stores/index';
import { IHeaderDTO, INoteDTO, IPaginationDTO, ITeamDTO, PaginationDTO } from '@/dtos';
import { SNACKSTATUS } from '@/stores/util';
import { useUpdateStatusStore } from '@/stores/modules';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
interface Props {
  branchId: string;
  yearId: string;
}
const props = defineProps<Props>();
const branchId = computed(() => props.branchId);
const yearId = computed(() => props.yearId);
const teamStore = useTeamStore();
const statusStore = useUpdateStatusStore();
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const query = teamStore.getTeamsForYearWithCheckin(branchId, yearId, pagination);
const loading = computed(() => query.isLoading.value);
const teams = computed(() => query.data.value?.data ?? []);
const count = computed(() => query.data.value?.count ?? 0);
const selectedTeam = ref<ITeamDTO | undefined>(undefined);
const showNotesModal = ref(false);
const currentNotes = ref<INoteDTO[]>([]);

const headersTeam = [
  { title: 'Name', key: 'name', align: 'start', sortable: true },
  { title: '', key: 'action', sortable: false },
] as IHeaderDTO[];

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};

const checkInTeam = async (item: ITeamDTO) => {
  selectedTeam.value = item;
  teamStore.checkIn.mutateAsync({ teamId: item.id, yearId: yearId.value });
};

const checkOutTeam = async (item: ITeamDTO) => {
  selectedTeam.value = item;
  teamStore.checkOut.mutateAsync({ teamId: item.id, yearId: yearId.value });
};

const showNotes = async (item: ITeamDTO) => {
  showNotesModal.value = true;
  currentNotes.value = item.teamCriteria[0].notes;
};

watch(
  () => statusStore.getStatus(`team-checkin-${selectedTeam.value?.id}`),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    const key = `criteria-${selectedTeam.value?.id}`;
    emit('snack', 'Team', value, statusStore.getError(key));
    if (selectedTeam.value?.name && value && value == 'success:update') {
      //TODO: ENABLE
      // sendCheckinToDiscord(selectedTeam.value?.name)
    }
    selectedTeam.value = undefined;
  },
);
</script>
